import * as styles from "./LoadingIndicator.module.scss";

import React from "react";

interface LoadingIndicatorProps {
	loading: boolean;
	scale?: number;
	title?: string;
}
export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
	loading,
	scale,
}) => {
	if (!loading) return null;
	return (
		<div
			className={styles.loadingindicator}
			style={{ transform: `scale(${scale})` }}
		/>
	);
};

export const LoadingPage: React.FC<LoadingIndicatorProps> = (loadingProps) => {
	return (
		<div className={styles.loadingPage}>
			{loadingProps.title && (
				<h1 className={styles.visuallyHidden}>{loadingProps.title}</h1>
			)}
			<LoadingIndicator {...loadingProps} />
		</div>
	);
};
export default LoadingIndicator;
